!function(module){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/hotelPers',['libs/ct_pers', 'vendor/moment.min', 'hotels/settings'], module)
	else
	//>>excludeEnd("requireTmpl");
		module(CT.Pers)
}(function(Pers, nope){
	
	$.extend(CT.settings[CT.app], {
		pers : {
			recent : {
				expirySearch : 5
			}
		}
	});
	
	
	
	
	/**
	 * Here's how the details will be saved:
	 *   'recent' : Pers.set('recent', {'ar' : 'JP nagar', 'ad' : {}, <whole object>})
	 *   'shortlisted' : Pers.set('shortlisted', {'city' : '1423', 'cid' : '12/10/12', 'cod' : '14/10/12', 'hids' : [1234, 5678]})
	 *   'lastbooked'
	 */
	var updaters = {
		'recent' : function(item, table){
			/**
			 *  newItem should look like:
			 *  {
		            "ar": "JP Nagar",
		            "cy" : "India",
		            "st" : "Karnataka",
		            "ct" : "Bangalore",
		            "dc" : "1234",
		            "cid": "26/1/2013",
		            "co": "28/1/2010",
		            "nor": 2,
		            "ad": {"1" : 2, "2" : 1},
		            "cd": {"1" : 2,"2":3},
		            "aoc": {"1" : [5,10],"2":[1,2,3]}
		        }
			 */
			var mapper = {
				children : 'cd',
				adults : 'ad',
				ca : 'aoc',
				childs : 'cd'
			}

			var newItem = {
				cid : item.chk_in,
				co : item.chk_out,
				nor : item.num_rooms,
				st : item.state,
				cy : item.country,
				ct : item.city,
				dst : item.dest_code,
				ar: item.area?item.area[0]:"",
				hnm : item.hotelName?item.hotelName:""
			}
			var tmp = {};
			_.each(['children', 'adults', 'ca'], function(keyType){
				_(item).pick(function(val, key){ return key.indexOf(keyType) > -1 }).each(function(idx, type){ tmp[type.charAt(type.length -1)] = idx; })
				newItem[mapper[keyType]] = tmp;
				
				tmp = {}
			})
			if(item.areaName) newItem.ar = item.areaName
			if(item.hotelId) newItem.hid = item.hotelId
			if(item.hotelName) newItem.hnm = item.hotelName
			if(item.poi) newItem.poi = item.poi[0]
			if(item.wg_rs && item.wg_rs == true ) newItem.wg_rs = true
			newItem._sts = new Date().getTime()
			return newItem
		},
		'hotelDetailsRecent' : function(item, table){
			
			var newItem = {
				url : item.url,
				cnm : item.cnm,
				hnm : item.hotelName?item.hotelName:"",
				taClass : item.taRatingClass,
				ta : item.taRating,
				sr : item.starRating,
				imgUrl : item.imgUrl,
				sd:item.sd
			}
			if(item.hotelName) newItem.hnm = item.hotelName
			//newItem._sts = new Date().getTime()
			return newItem
		},

		'recentlyViewed' :  function(item,table){
			return item;
		},

		'shortlisted' : function(item, table){
			var obj = {}
			var data = {}
			var key = item.cid? item.cid + '-' + item.cod : '-'
			data[key] = item.hids
			obj[item.name] = data
			return obj
		},
		'last_booked' : function(item, table){
			return item
		},
		'guided_nav' : function(){

		},
		'bookflow_dropoff' : function(){

		},
		'upcoming_trips' : function(){

		},
		'default_pref' : function(){

		},
		'last_refund_up' : function(item, table){
			return item
		},
		'last_completed' : function(item){
			return item
		},
		'filters' : function(){

		},
		'threshold' : function(){

		}
	}


	// Array updaters
	var arrayUpdaters = {
		'recent' : function(arr, item, table){
			//arr = _(arr).uniq(function(val){ return _.serialize(val) }).value()
			// return arr

			//Restricting recnet search store in local storage to last 10 seaech
			arr = _.filter(arr,function(ele){
				return _.serialize(ele) != _.serialize(item);
			});
			arr.push(item);
			arr = _(arr).slice(-10).value();
			return arr;
		},

		'recentlyViewed' : function(arr,item,table){
			arr = _.filter(arr,function(ele){
				return _.serialize(ele) != _.serialize(item);
			});
			arr.push(item);
			arr = _(arr).slice(-4).value();
			return arr;
		},

		'hotelDetailsRecent' : function(arr, item, table){
			arr = _(_(arr).uniq(function(val){ return _.serialize(val) })).value()
			//arr = _.without(arr,item)
			return arr
		},

		'shortlisted' : function(arr, item, table){
			var hash = arr[0]
			var toUpdate = (typeof hash[item.name] != 'undefined') ? hash[item.name]  : hash;


			$.extend(toUpdate, item)
			arr[0] = hash
			return arr
		},

		'last_booked' : function(arr, item, table){
			return arr
		}

	}

	// Expiry modifiers
	var expMods = {}
	
	var expChecks = {
		'recent' : function(item){
			var isPastChkIn = item.cid != "" ? +new Date() > (+new Date(CT.utils.swapDayMonth(item.cid)) + 86399000) : false;
			var isPastSearchDate = (+new Date() - item._sts) > (86400 * CT.settings[CT.app].pers.recent.expirySearch * 1000)
			return (isPastChkIn || isPastSearchDate) ? nope : item
		}
	}

	_.each(updaters, function(fn, key){
		Pers.add(key, fn)
	})
	_.each(arrayUpdaters, function(fn, key){
		Pers.add(key, fn, 'array')
	})
	_.each(expMods, function(fn, key){
		Pers.add(key, fn, 'expires')
	})
	_.each(expChecks, function(fn, key){
		Pers.add(key, fn, 'expiryCheck')
	})
	

	return Pers
})
;
